// src/pages/sliders/Sliders.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import SlidersTable from "../../components/sliders/SlidersTable";

const Sliders = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <SlidersTable />
        </WrapperSection>
    );
};

export default Sliders;